import { DefaultState, DropdownItem } from 'store/types';
import { LodgingPolicyForm } from '../post-lodging-policy/types';

export const GET_LODGING_POLICY_REQUEST = 'GET_LODGING_POLICY_REQUEST';
export const GET_LODGING_POLICY_SUCCESS = 'GET_LODGING_POLICY_SUCCESS';
export const GET_LODGING_POLICY_FAILURE = 'GET_LODGING_POLICY_FAILURE';
export const GET_LODGING_POLICY_CLEAR = 'GET_LODGING_POLICY_CLEAR';

export interface LodgingPolicyFormData extends LodgingPolicyForm {
  lodgingPolicyStatusesSelectList: DropdownItem[];
}

export type GetLodgingPolicyState = DefaultState & {
  contents?: LodgingPolicyFormData;
};

interface GetLodgingPolicyRequest {
  type: typeof GET_LODGING_POLICY_REQUEST;
}

interface GetLodgingPolicySuccess {
  type: typeof GET_LODGING_POLICY_SUCCESS;
  contents: LodgingPolicyFormData;
}

interface GetLodgingPolicyFailure {
  type: typeof GET_LODGING_POLICY_FAILURE;
}

interface GetLodgingPolicyClear {
  type: typeof GET_LODGING_POLICY_CLEAR;
}

export type GetLodgingPolicyActionTypes = GetLodgingPolicyRequest | GetLodgingPolicySuccess | GetLodgingPolicyFailure | GetLodgingPolicyClear;

export enum LodgingPolicyStatuses {
  Active = 'Active',
  Inactive = 'Inactive',
}
